// @flow

import React from 'react';
import PropTypes from "prop-types";
import T from './T';

const propTypes = {
    className: PropTypes.string,
	style: PropTypes.object
};

const defaultProps = {
};

class Tlabel extends T {
	render() {
		return (<label className={this.props.className} style={this.props.style}>{this.trans(this.props.children)}</label>);
	}
}

Tlabel.propTypes = propTypes;
Tlabel.defaultProps = defaultProps;

export default Tlabel;
